import TwoDayWeather from "./TwoDayWeather";

export default TwoDayWeather;